{
  "startne": {
    "main": {
      "title": "Ispezioni CAMO - Liste di partenza",
      "titleMotorna": "Aeromobili a motore",
      "titleJadralna": "Alianti",
      "titleUltralight": "Ultraleggeri"
    },
    "buttons": {
      "nazaj": "Indietro",
      "nazajGlavni": "Menu principale",
      "natisni": "Stampa",
      "poslji": "Invia",
      "brisiIzbiro": "Briši izbiro"
    },
    "nav": {
      "jadralna": "Ispezioni CAMO - Liste di partenza degli alianti",
      "motorna": "Ispezioni CAMO - Liste di partenza degli aeromobili a motore",
      "ultralight": "Ispezioni CAMO - Liste di partenza degli ultraleggeri"
    },
    "labels": {
      "datumOd": "Data DAL:",
      "datumDo": "Data AL:",
      "klubL": "Seleziona il club dell'aeromobile:",
      "klubP": "Seleziona il club del pilota:",
      "namen": "Seleziona lo scopo:",
      "naloga": "Seleziona il compito:",
      "pilot": "Seleziona il pilota:",
      "reg": "Seleziona la registrazione dell'aeromobile:",
      "stPristankov": "N. di atterraggi:",
      "stLetov": "N. di voli:",
      "casVZraku": "Tempo in volo:"
    },
    "data": {
      "title": "Dati",
      "stPristankov": "N. di atterraggi:",
      "stLetov": "N. di voli:",
      "casVZraku": "Durata:"
    },
    "table": {
      "reg": "REG",
      "vzlet": "DECOLLO",
      "pilot": "PILOTA",
      "trajanje": "DURATA",
      "naloga": "COMPITO",
      "datum": "DATA",
      "odklop": "SGANCIO",
      "pristanek": "ATTERRAGGIO",
      "titleM": "VOLI A MOTORE",
      "titleJ": "VOLI IN ALIANTE",
      "titleU": "VOLI ULTRALEGGERI"
    }
  }
}